import { render, staticRenderFns } from "./contestQuiz.html?vue&type=template&id=23f351d0&scoped=true&"
import script from "./contestQuiz.js?vue&type=script&lang=js&"
export * from "./contestQuiz.js?vue&type=script&lang=js&"
import style0 from "./contestQuiz.scss?vue&type=style&index=0&id=23f351d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f351d0",
  null
  
)

export default component.exports